export default __webpack_public_path__ + "static/media/iconCommunity.d063ab9b.png";